import script from "./groupCcl.vue?vue&type=script&setup=true&lang=js"
export * from "./groupCcl.vue?vue&type=script&setup=true&lang=js"

import "./groupCcl.vue?vue&type=style&index=0&id=3cf20223&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf20223"]])

export default __exports__